<script lang="ts">
	import type { PoiScheme } from '../../types';
	import ButtonAddToItinerary from '$lib/components/atoms/button/ButtonAddToItinerary.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import TheForkWidget from '$lib/components/theFork/TheForkWidget.svelte';
	import * as m from '$paraglide/messages';
	import { createEventDispatcher } from 'svelte';

	export let scheme: PoiScheme | undefined = undefined;
	export let isFloating: boolean = false;
	export let bookUrl: string | undefined = undefined;
	export let showItineraryButton = true;
	export let theForkUrl: string | undefined = undefined;
	export let hasShadow: boolean = true;
	export let showLearnMoreButton: boolean = false;
	export let learnMoreLabel: string | undefined = undefined;
	export let infoUrl: string | undefined = undefined;

	function getDynamicClasses(isFloating: boolean, hasShadow: boolean) {
		const classes = isFloating ? 'bg-neutral-weak md:bg-neutral-weakest shadow-first-inverted' : '';
		return hasShadow ? `${classes} p-2 md:rd-2` : classes;
	}

	$: dynamicClasses = getDynamicClasses(isFloating, hasShadow);

	const dispatch = createEventDispatcher<{
		itineraryClick: void;
		bookClick: void;
		learnMoreClick: void;
	}>();
</script>

<div class="flex flex-row gap-2 items-center bg-neutral-weakest {dynamicClasses}">
	{#if theForkUrl}
		<TheForkWidget class="" size="md" url={theForkUrl} onBookClick={() => dispatch('bookClick')} />
	{:else if bookUrl && !showLearnMoreButton}
		<Link
			icon={scheme}
			label={m.poi_actions__book()}
			button="filled"
			size="md"
			href={bookUrl}
			target="_blank"
			rel="external"
			onclick={() => dispatch('bookClick')}
		/>
	{/if}
	{#if showItineraryButton}
		<ButtonAddToItinerary
			onclick={() => dispatch('itineraryClick')}
			variant={bookUrl && !showLearnMoreButton ? 'outline' : 'filled'}
		/>
	{/if}
	{#if showLearnMoreButton && bookUrl}
		<Link
			icon="open-in-new"
			label={learnMoreLabel}
			button="outline"
			size="md"
			href={bookUrl}
			target={scheme === 'hotel' ? '_self' : '_blank'}
			rel="external"
			onclick={() => dispatch('learnMoreClick')}
		/>
	{/if}
	{#if infoUrl}
		<Link
			icon="open-in-new"
			iconPosition="right"
			label={m.poiCard__seeDetails()}
			button="outline"
			color="light"
			size="md"
			href={infoUrl}
			target="_blank"
			rel="external"
			onclick={() => dispatch('learnMoreClick')}
		/>
	{/if}
</div>
